import styled from 'styled-components/macro';

export const HeaderGroup = styled.div`
  position: relative;
  width: auto;
  height: 100%;
  font-size: ${({ theme }) => theme.h5}px;
  color: ${({ theme }) => theme.headerBlack};
  font-family: ${({ theme }) => theme.primaryFontLight};
  float: right;
  padding-left: 15px;
  padding-top: 6px;
  cursor: pointer;

  div {
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  }
`;

export const FoldedMenu = styled.div`
  min-height: 35px;
  min-width: 150px;
  background-color: white;
  position: absolute;
  right: 0;
  ${({ invert }) => (invert ? 'bottom: 50px' : 'top: 50px')};
  box-shadow: 3px 3px 5px 3px rgba(0, 0, 0, 0.3);
`;

export const FoldedMenuTrigger = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: ${({ theme }) => theme.headerBlack};
    margin-left: 5px;
  }
`;

export const FoldedMenuOption = styled.button`
  border-style: none;
  width: 100%;
  text-align: left;
  background-color: transparent;
  line-height: 35px;
  font-size: ${({ theme }) => theme.h5}px;
  color: ${({ theme }) => theme.dark};
  font-family: ${({ theme }) => theme.primaryFontLight};
  padding: 0 15px 0 15px;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.dark};
    color: ${({ theme }) => theme.light};
  }
`;
